import { render, staticRenderFns } from "./NewYearPage.vue?vue&type=template&id=6e0c3f3e&scoped=true&"
import script from "./NewYearPage.vue?vue&type=script&lang=js&"
export * from "./NewYearPage.vue?vue&type=script&lang=js&"
import style0 from "./NewYearPage.vue?vue&type=style&index=0&id=6e0c3f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c3f3e",
  null
  
)

export default component.exports